export const Settings = () => {
  //production
  return {
    REVERT_MODEL_URL: "https://marketingapi.heatcraftrpd.com/xref/revertModel",
    MODEL_SEARCH_URL:
      "https://marketingapi.heatcraftrpd.com/xref/v2/model_search/",
    NEW_MODEL_SEARCH_URL:
      "https://marketingapi.heatcraftrpd.com/xref/v2/new_model_search/",
    LOAD_MODEL_URL: "https://marketingapi.heatcraftrpd.com/xref/v2/models/",
    LOAD_NEW_MODEL_URL:
      "https://marketingapi.heatcraftrpd.com/xref/v2/new_model/",
    LIST_INVALID_PACKAGE_URL:
      "https://marketingapi.heatcraftrpd.com/xref/v2/invalid_option_packages/"
  };
  //stage
  /*return {
    REVERT_MODEL_URL:
      "https://marketingapi.heatcraftrpdqa.com/xref/revertModel",
    MODEL_SEARCH_URL:
      "https://marketingapi.heatcraftrpdqa.com/xref/v2/model_search/",

    NEW_MODEL_SEARCH_URL:
      "https://marketingapi.heatcraftrpdqa.com/xref/v2/new_model_search/",
    LOAD_MODEL_URL: "https://marketingapi.heatcraftrpdqa.com/xref/v2/models/",
    LOAD_NEW_MODEL_URL:
      "https://marketingapi.heatcraftrpdqa.com/xref/v2/new_model/",
    LIST_INVALID_PACKAGE_URL:
      "https://marketingapi.heatcraftrpdqa.com/xref/v2/invalid_option_packages/"
  }; *///adt
  /*
  ///logidots stage
  //stage
  return {
    REVERT_MODEL_URL:
      "https://marketingapi.heatcraftrpdqa.com/xref/revertModel",
    MODEL_SEARCH_URL:
      "http://api.heatcraft.staging.on.logidots.com/v2/model_search/",

    NEW_MODEL_SEARCH_URL:
      "http://api.heatcraft.staging.on.logidots.com/v2/new_model_search/",
    LOAD_MODEL_URL: "http://api.heatcraft.staging.on.logidots.com/v2/models/",
    LOAD_NEW_MODEL_URL:
      "http://api.heatcraft.staging.on.logidots.com/v2/new_model/",
    LIST_INVALID_PACKAGE_URL:
      "https://marketingapi.heatcraftrpdqa.com/xref/v2/invalid_option_packages/"
  };*/
};
